import systemConfig from "./system-config.ts";

class Config {

    /** 系统配置 */
    system = systemConfig;

}

export default new Config();
